import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export const itinerarySlice = createSlice({
  name: 'itinerary',
  initialState,
  reducers: {
    getItineraries: (state) => {
      state.loading = true;
    },
    addItinerary: (state) => {
      state.loading = true;
    },
    updateItinerary: (state) => {
      state.loading = true;
    },
    removeItinerary: (state) => {
      state.loading = true;
    },
    successItinerary: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    failedItinerary: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getItineraries,
  addItinerary,
  updateItinerary,
  removeItinerary,
  successItinerary,
  failedItinerary,
} = itinerarySlice.actions;

export default itinerarySlice.reducer;
